// Extend the PredictiveSearch class to handle skeleton loading (Apple-style)
document.addEventListener('DOMContentLoaded', function() {
  // Wait for PredictiveSearch to be defined
  setTimeout(() => {
    if (typeof PredictiveSearch === 'undefined') return;

    // Create skeleton HTML matching the new Apple-style layout
    const skeletonTemplate = `
    <div class="flex flex-col animate-pulse">
      <!-- Scrollable Results Area -->
      <div class="flex-1">

        <!-- Suggestions Skeleton - Vertical List -->
        <section class="px-4 pt-4 pb-2">
          <div class="h-3 bg-base-200 rounded w-20 mb-4"></div>
          <ul class="space-y-1">
            <li class="flex items-center gap-3 py-3">
              <div class="w-5 h-5 bg-base-200 rounded"></div>
              <div class="flex-1 h-4 bg-base-200 rounded" style="width: 70%;"></div>
            </li>
            <li class="flex items-center gap-3 py-3">
              <div class="w-5 h-5 bg-base-200 rounded"></div>
              <div class="flex-1 h-4 bg-base-200 rounded" style="width: 85%;"></div>
            </li>
            <li class="flex items-center gap-3 py-3">
              <div class="w-5 h-5 bg-base-200 rounded"></div>
              <div class="flex-1 h-4 bg-base-200 rounded" style="width: 60%;"></div>
            </li>
            <li class="flex items-center gap-3 py-3">
              <div class="w-5 h-5 bg-base-200 rounded"></div>
              <div class="flex-1 h-4 bg-base-200 rounded" style="width: 75%;"></div>
            </li>
          </ul>
        </section>

        <!-- Products Skeleton - Horizontal Scroll -->
        <section class="py-4">
          <div class="h-3 bg-base-200 rounded w-16 mb-4 mx-4"></div>
          <div class="flex gap-3 overflow-x-hidden px-4 pb-2">
            ${[1,2,3,4].map(() => `
              <div class="flex-shrink-0 w-36">
                <!-- Product Image Skeleton -->
                <div class="aspect-square bg-base-200 rounded-2xl mb-2"></div>
                <!-- Title Skeleton -->
                <div class="space-y-1.5">
                  <div class="h-3.5 bg-base-200 rounded w-full"></div>
                  <div class="h-3.5 bg-base-200 rounded w-3/4"></div>
                </div>
                <!-- Price Skeleton -->
                <div class="h-3.5 bg-base-200 rounded w-16 mt-2"></div>
              </div>
            `).join('')}
          </div>
        </section>

        <!-- Pages Skeleton -->
        <section class="px-4 py-4 border-t border-base-200">
          <div class="h-3 bg-base-200 rounded w-12 mb-4"></div>
          <ul class="space-y-1">
            <li class="flex items-center gap-3 py-3">
              <div class="w-5 h-5 bg-base-200 rounded"></div>
              <div class="flex-1 h-4 bg-base-200 rounded" style="width: 65%;"></div>
            </li>
            <li class="flex items-center gap-3 py-3">
              <div class="w-5 h-5 bg-base-200 rounded"></div>
              <div class="flex-1 h-4 bg-base-200 rounded" style="width: 80%;"></div>
            </li>
          </ul>
        </section>

      </div>

      <!-- Footer Skeleton -->
      <div class="border-t border-base-200 p-4">
        <div class="h-12 bg-base-200 rounded-xl w-full"></div>
      </div>
    </div>
  `;

  // Override the setLiveRegionLoadingState method
  const originalSetLoadingState = PredictiveSearch.prototype.setLiveRegionLoadingState;
  PredictiveSearch.prototype.setLiveRegionLoadingState = function() {
    // Call original method
    originalSetLoadingState.call(this);

    // Replace placeholder with skeleton
    const placeholder = this.querySelector('[data-predictive-search-placeholder]');
    if (placeholder) {
      placeholder.style.display = 'none';
    }

    // Add skeleton if not already present
    if (!this.querySelector('.animate-pulse')) {
      this.predictiveSearchResults.innerHTML = skeletonTemplate;
    }
  };

  // Override the renderSearchResults method
  const originalRenderResults = PredictiveSearch.prototype.renderSearchResults;
  PredictiveSearch.prototype.renderSearchResults = function(resultsMarkup) {
    // Hide placeholder if it exists
    const placeholder = this.querySelector('[data-predictive-search-placeholder]');
    if (placeholder) {
      placeholder.style.display = 'none';
    }

    // Call original method
    originalRenderResults.call(this, resultsMarkup);
  };

  // Override the closeResults method to show placeholder again
  const originalCloseResults = PredictiveSearch.prototype.closeResults;
  PredictiveSearch.prototype.closeResults = function(clearSearchTerm = false) {
    // Call original method
    originalCloseResults.call(this, clearSearchTerm);

    // Show placeholder again if search is cleared
    if (clearSearchTerm) {
      const placeholder = this.querySelector('[data-predictive-search-placeholder]');
      if (placeholder) {
        placeholder.style.display = 'flex';
      }
      // Clear any skeleton or results
      this.predictiveSearchResults.innerHTML = '';
    }
  };
  }, 100);
});
